import { useSearchParams } from "react-router-dom";
import Header from "@/sections/Header";
import FooterSection from "@/sections/Footer";
import { LandingCareersFirst, LandingCompact, LandingCurrent, LandingHybrid, LandingStoryFirst } from "@/components/landing/LandingLayouts";
import { PreviewToolbar, useNoIndex } from "@/components/preview/PreviewToolbar";

const OPTIONS = [
  { id: "hybrid", label: "Hybrid", short: "Hybrid", blurb: "Hero → featured in → explore cards → Careers Hub → Job Board → events → get involved, then the rest of DCYB below.", Component: LandingHybrid },
  { id: "careers", label: "1 · Careers-First", short: "1 · Careers", blurb: "Hero → live Job Board → Careers Hub tools → community → events → get involved. Built for job seekers.", Component: LandingCareersFirst },
  { id: "story", label: "2 · Story-First", short: "2 · Story", blurb: "Hero → what DCYB does → featured in → community → events → get involved. Leads with the mission.", Component: LandingStoryFirst },
  { id: "compact", label: "3 · Compact", short: "3 · Compact", blurb: "Hero → featured in → big cards to every area of DCYB → get involved. One short scroll.", Component: LandingCompact },
  { id: "current", label: "Current (Live)", short: "Live", blurb: "The live homepage: the original section order under the new hero.", Component: LandingCurrent },
];

export default function LandingOptionsPage() {
  const [params, setParams] = useSearchParams();
  const active = OPTIONS.find((option) => option.id === params.get("option")) || OPTIONS[0];
  useNoIndex("Homepage Layout Options · DCYB Private Preview");
  const select = (id) => { setParams({ option: id }, { replace: true }); window.scrollTo({ top: 0 }); };
  const { Component } = active;
  return (
    <main data-testid="landing-options-page" className="relative">
      <Header />
      <PreviewToolbar heading="Private preview · Homepage layout options" options={OPTIONS} active={active} onSelect={select} testId="landing-options-toolbar" descriptionTestId="landing-options-description" buttonPrefix="landing-switcher-btn" />
      <div data-testid={`landing-options-preview-${active.id}`} key={active.id}><Component /></div>
      <FooterSection />
    </main>
  );
}
